import styled from '@emotion/styled';
import Icon from 'presentations/views/components/atoms/Icon';
import IconButton from 'presentations/views/components/atoms/IconButton';
import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import { primary, white } from 'presentations/views/styles/color';
import { useState } from 'react';

export interface Props {
  title: string;
  description: string;
}

export default function Component(props: Props) {
  const [isOpenToc, setIsOpenToc] = useState<boolean>(false);

  const onClickOpenToc = () => {
    const isOpen = !isOpenToc;
    setIsOpenToc(isOpen);
  };

  return (
    <FaqContainer>
      <FaqHeader>
        <FaqTitle>{props.title}</FaqTitle>
        <IconButton onClick={onClickOpenToc}>
          <TocCloseIcon name={`chevron-${isOpenToc ? 'up' : 'down'}`} />
        </IconButton>
      </FaqHeader>
      <FaqList isOpen={isOpenToc}>
        <FaqListItem>
          <FaqListItemText>{props.description}</FaqListItemText>
        </FaqListItem>
      </FaqList>
    </FaqContainer>
  );
}

const FaqContainer = styled.div`
  margin-top: ${spacing(16)};
  padding: ${spacing(16)} ${spacing(24)};

  background-color: ${white};
  border-radius: ${borderRadius(16)};

  ${mediaMax.tablet} {
    margin: ${spacing(20)} 0 0 0;
    padding: ${spacing(12)} ${spacing(20)} ${spacing(12)} ${spacing(20)};
  }
`;

const FaqTitle = styled.div`
  display: flex;
  align-items: center;
  font-weight: ${fontWeight('bold')};
  line-height: 160%;

  ${mediaMax.tablet} {
    font-size: ${fontSize(13)};
  }
`;

const FaqList = styled.ul<{ isOpen: boolean }>`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
`;

const FaqListItem = styled.li`
  margin-bottom: ${spacing(4)};
  cursor: pointer;
  :last-of-type {
    margin-bottom: 0;
  }

  ${mediaMax.tablet} {
    font-size: ${fontSize(13)};
  }
`;
const FaqListItemText = styled.span`
  display: block;
`;

const FaqHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const TocCloseIcon = styled(Icon)`
  color: ${primary};
`;
